// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_discovery_heading = /** @type {(inputs: {}) => string} */ () => {
	return `A Swiss engineer walked barefoot through a rice paddy. His back pain disappeared.`
};

const el_tech_discovery_heading = /** @type {(inputs: {}) => string} */ () => {
	return `Ένας Ελβετός μηχανικός περπάτησε ξυπόλητος σε ορυζώνα. Ο πόνος στη μέση του εξαφανίστηκε.`
};

const ru_tech_discovery_heading = /** @type {(inputs: {}) => string} */ () => {
	return `Швейцарский инженер прошёлся босиком по рисовому полю. Боль в спине исчезла.`
};

const he_tech_discovery_heading = /** @type {(inputs: {}) => string} */ () => {
	return `מהנדס שוויצרי הלך יחף בשדה אורז. כאבי הגב שלו נעלמו.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_discovery_heading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_discovery_heading(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_discovery_heading", locale)
	if (locale === "en") return en_tech_discovery_heading(inputs)
	if (locale === "el") return el_tech_discovery_heading(inputs)
	if (locale === "ru") return ru_tech_discovery_heading(inputs)
	if (locale === "he") return he_tech_discovery_heading(inputs)
	return "tech_discovery_heading"
};